import { useMutation } from "@tanstack/react-query";
import { discountService } from "..";
import { CreateCustomerGroupDiscountPayload } from "../type";

function useCreateDiscountByCustomerGroup() {
  return useMutation({
    mutationFn: (command: CreateCustomerGroupDiscountPayload) => {
      return discountService.createDiscountByCustomerGroup(command);
    },
  });
}

export default useCreateDiscountByCustomerGroup;
